import {
  FirebaseConfigType,
  initFirebase,
  sendAnalyticsEvent as FirebaseSendEvent,
} from '@/util/analytics/firebase';
import {
  AnalyticsProviderType,
  AnalyticsProviderTypes,
} from '@/providers/analyticsProvider';

const sendAnalyticsEvent = async (
  providers: AnalyticsProviderType[],
  eventName: string,
  meta?: any,
): Promise<void> => {
  providers.forEach((provider) => {
    if (provider.type === AnalyticsProviderTypes.GOOGLE) {
      FirebaseSendEvent(eventName, meta, provider.id);
    }
    // handle other analytics provider here
  });
};

const initAnalytics = ({
  provider,
  configType,
  user,
  providerId,
}: {
  provider: AnalyticsProviderTypes;
  configType: FirebaseConfigType;
  user?: any;
  providerId?: string;
}): void => {
  if (provider === AnalyticsProviderTypes.GOOGLE) {
    initFirebase({ config: configType as FirebaseConfigType, providerId });
  }
  //handle additional providers here
};

export { initAnalytics, sendAnalyticsEvent };
